import $ from 'jquery';

$(() => {
  if ($( 'body.admin-sub_clients' ).length > 0) {
    $( 'ul.nav li a' ).removeClass( 'active' );
    $( 'li.sub_clients a' ).addClass( 'active' );

    if ($( 'body.admin-sub_clients-index' ).length > 0) {
      $( 'table.sub_clients' ).on( 'click-row.bs.table', (element, row) => {
        const sub_client_id = row.id;
        const url = `/admin/sub_clients/${sub_client_id}`;

        return window.location = url;
      });

      $( document ).one( 'click', 'button.new', (event) => {
        const $element = $( event.target )
          .closest( 'button' );

        window.location = $element[0].dataset.url;
      });
    }

    if ($( 'body.admin-sub_clients-show' ).length > 0) {
      $( document ).one( 'click', 'button.edit', (event) => {
        const $element = $( event.target )
          .closest( 'button' );

        window.location = $element[0].dataset.url;
      });

      let searchTimeout;
      const $searchInput = $( '#printer-search' );
      const $results = $( '#printer-search-results' );
      const $status = $( '#printer-search-status' );
      const searchUrl = $searchInput.data( 'url' );

      $searchInput.on( 'keyup', () => {
        clearTimeout( searchTimeout );
        const query = $searchInput.val().trim();

        if (query.length < 6) {
          $results.empty();
          $status.text( query.length > 0 ? 'Type at least 6 characters to search.' : '' );
          return;
        }

        $status.text( 'Searching...' );

        searchTimeout = setTimeout( () => {
          $.getJSON( searchUrl, { search: query }, (response) => {
            $results.empty();
            $status.text( '' );

            if (response.data.length === 0) {
              $status.text( 'No matching printers found.' );
              return;
            }

            const $list = $( '<ul class="list-group"></ul>' );

            response.data.forEach( (printer) => {
              const assignPath = searchUrl.replace( '/search_printers', '/assign_printers' );
              const $item = $( `
                <li class="list-group-item d-flex justify-content-between align-items-center">
                  <span>${printer.name} <code>${printer.api_id.split('-').pop()}</code></span>
                  <form method="post" action="${assignPath}">
                    <input type="hidden" name="_method" value="patch" />
                    <input type="hidden" name="authenticity_token" value="${$('meta[name=csrf-token]').attr('content')}" />
                    <input type="hidden" name="add_printer_ids[]" value="${printer.id}" />
                    <button type="submit" class="btn btn-sm btn-success">Add</button>
                  </form>
                </li>
              ` );

              $list.append( $item );
            });

            $results.append( $list );
          });
        }, 300 );
      });
    }
  }
});
